import React, { useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    dateType,
    imageType,
    lineData = [], // 折线 数据
    isNodata,
    metric,
    titleNow,
    chartLoading,
    setChartLoading,
    topChartsType,
    renderType,
  } = props;

  // console.log('Visualis', props);

  const isPercentLine = useMemo(() => {
    switch (renderType) {
      case RenderType.GROWTH_ONLY:
        return true;
      default:
        return false;
    }
  }, [topChartsType]);

  const cardRef = useRef(null);

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      const lineNum = list[i].metrics
        ? list[i].metrics?.find((item: any) => item.metric == metric)?.value
        : list[i].value
        ? list[i].value
        : null;
      arr.push({
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: isPercentLine ? lineNum * 100 : lineNum,
      });
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    if (!Array.isArray(lineData) || lineData?.length < 1) return [];
    const objTemp = {
      id: titleNow,
      name: titleNow,
      history: getRpdTypeData(lineData || []),
    };
    return {
      source: [objTemp],
    };
  }, [lineData, metric, dateType, titleNow]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: 'source',
    topChartsType: 'pcconsole-stats-line',
    imageType,
    titleNow,
    chartType,
    setChartLoading,
    dateType,
    isPercentLine,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
